export default "__VITE_ASSET__CFnQ9ekR__"